module.exports = __webpack_public_path__ + "img/brand9-head.397780ba.png";